import { MASTHEAD_PHONE_FLEX } from '../table-session/mastheadChrome';

/**
 * The compact phone row inside the frame's masthead (feature 029).
 *
 * <p>Below `md` the status line under the frame is `display:none` — there is no height for it — so
 * this row is where a phone reads its position, and the `sr-only` category name beside it is what
 * keeps the frame's `h1` non-empty at those widths. It carries the two facts worth the pixels: how
 * far through the category the editor is, and the serial, which the client quotes constantly when
 * reporting a problem. Everything else is one tap away behind the ⓘ.</p>
 *
 * <p>It deliberately does NOT reuse the practice `MastheadInfoRow`: that component's shape is a
 * streak and a score in a brass pill, and this page has neither. The classes are the same, because
 * the strip's height is set by its tallest control and must not change between surfaces.</p>
 */
export function ConceptualMastheadInfoRow({
  position,
  total,
  serial,
}: {
  position: number;
  total: number;
  serial: number;
}) {
  return (
    <span
      aria-hidden="true"
      className={`flex items-center gap-1.5 font-sans text-sm font-semibold text-cream ${MASTHEAD_PHONE_FLEX}`}
      data-testid="conceptual-masthead-info"
    >
      <span>
        {position}/{total}
      </span>
      {/* The `#` stays — without it the serial reads as a second number belonging to the position. */}
      <span className="whitespace-nowrap text-xs font-normal text-sand sm:text-sm">#{serial}</span>
    </span>
  );
}
